export function selectWaitlistParty(id: number): BaseTockAction {
  return {
    type: 'SELECT_WAITLIST_PARTY',
    payload: id,
  };
}

export function resetWaitlistParty(): BaseTockAction {
  return {
    type: 'SELECT_WAITLIST_PARTY',
    payload: null,
  };
}
